module.exports = __webpack_public_path__ + "public/files/img/arab_child.1a817a95.png";